const appColors = {
  brandWhite: {
    900: '#FFFFFF',
  },

  brandGrey: {
    50: '#F2F2F2',
    100: '#D9D9D9',
    200: '#BFBFBF',
    300: '#A6A6A6',
    400: '#8C8C8C',
    500: '#737373',
    700: '#404040',
    800: '#262626',
    900: '#0D0D0D',
  },

  brandPrimary: {
    50: '#FFECE5',
    100: '#F9C8BA',
    300: '#E87663',
    400: '#E14B38',
  },

  brandSecondary: {
    100: '#E2CFDB',
    200: '#CDB1C1',
    500: '#8B5971',
    300: '#B891A7',
    400: '#A4728C',
    700: '#4D313D',
  },

  brandRed: {
    100: '#C7261E',
  },
};

export default appColors;
